$(function () {
    $('.sgkProductsFilter select').change(function () {
        var list = $(this).closest('.sgkProductsFilter').find('.sgkProductsFilterList');
        if ($(this).val() > 0 && list.find('.sgkProductFilter' + $(this).val()).length == 0) {
            list.append($('<span/>').addClass('tag badge badge-primary').attr('data-filterid', $(this).val()).append($('<span/>').html($(this).find("option:selected").text())));
        }
        sgkProductsFilter($(this).closest('.sgkContentProductList'));
    })

    $(document).on('click', '.sgkProductsFilter .tag', function () {
        var products = $(this).closest('.sgkContentProductList');
        $(this).remove();
        sgkProductsFilter(products);
    })
})

function sgkProductsFilter(products) {
    if (products.find('.sgkProductsFilterList > span').length > 0) {
        products.find('.sgkProduct').hide();
        products.find('.sgkProductsFilterList > span').each(function () {
            products.find('.sgkProductFilter' + $(this).data('filterid')).show();
        })
    } else {
        products.find('.sgkProduct').show();

    }
}